module.exports = __webpack_public_path__ + "static/media/image-5.6547f62a.jpg";